
  import InternationalTradeRussiaEconRev from '../InternationalTrade/InternationalTradeRussiaEconRev.vue';
  import InvestmentsRussiaEconRev from '../investments/InvestmentsRussiaEconRev.vue';
  import RussiaLimitations from '../limitations/RussiaLimitations.vue';
  import EconRevTemplate from './EconRevTemplate.vue';

  export default {
    name: 'RussiaEconRev',
    components: {
      InternationalTradeRussiaEconRev,
      InvestmentsRussiaEconRev,
      RussiaLimitations,
      EconRevTemplate,
    },
    props: {
      countryId: {
        type: String,
        default: '',
      },
      unfriendlyCountryInfo: {
        type: Object,
        default: () => ({}),
      },
    },
    data(): {
      year: number | null;
    } {
      return {
        year: null,
      };
    },
    methods: {
      onYearChanged(year: number) {
        this.year = year;
      },
    },
  };
